import { useParams } from 'react-router-dom';
import { useAsync } from 'react-async';
import { useTranslation } from 'react-i18next';
import { KoobContainer, KoobPageHeader, KoobSkeleton } from '@koob/ui';

import { getOneTrip } from 'api/trip';
import BookingForm from 'components/Hotel/Booking/Edit/BookingForm';
import KoobLayout from 'components/Koob/KoobLayout';

// A booked trip: its hotel and experience bookings.
export default function TripBookings() {
  const { tripId } = useParams();
  const { t } = useTranslation('folders');

  const { data, isLoading, reload } = useAsync({
    promiseFn: getOneTrip,
    tripId,
    watch: tripId,
  });

  const trip = data?.data;
  const hasTrip = Boolean(trip?.bookings);

  return (
    <KoobLayout
      header={
        <KoobPageHeader
          title={trip && (trip.name || t('pages:untitledTrip'))}
          breadcrumbs={[{ label: t('title'), to: '/folders' }]}
        />
      }
    >
      <KoobContainer>
        {isLoading || !trip ? (
          <KoobSkeleton shape="rows" />
        ) : (
          <BookingForm
            booking={trip.bookings?.[0] ?? trip}
            reload={reload}
            tripExperiencesBooked={trip.bookings?.filter(item => !item.hotel)}
            tripRoomsBooked={trip.bookings?.filter(item => item.hotel)}
            hasTrip={hasTrip}
          />
        )}
      </KoobContainer>
    </KoobLayout>
  );
}
